module.exports = __webpack_public_path__ + "img/verify-email-v2.fb2b930b.svg";